// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  AccountViewListingAdproductDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
} from '../..';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/advertising';

/**
 * Get single family customer account view property listing advertising
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<AdvertisingParams, never, AccountViewListingAdproductDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/list';

/**
 * Get single family customer account view property list
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list = (
  getParams: ListParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ListParams, never, AccountViewListingsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/options';

/**
 * Get single family customer account view property listing options
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options = (
  getParams: OptionsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<OptionsParams, never, AccountViewListingOptionsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/prospects';

/**
 * Get single family customer account view property prospects
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ProspectsParams, never, AccountViewListingProspectsDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/sources';

/**
 * Get single family customer account view property listing sources
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<SourcesParams, never, AccountViewListingSourcesDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/status';

/**
 * Get single family customer account view property listing status
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status = (
  getParams: StatusParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<StatusParams, never, AccountViewListingStatusOverviewDto>({
    getParams: getParams,
    endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
